import Vue from 'vue';
import './plugins/vuetify';
import store from './store/store';
import App from './App.vue';
import router from './routers/router';

import Toasted from 'vue-toasted';

import VueJwtDecode from 'vue-jwt-decode'

import i18n from '@/i18n';
Vue.config.productionTip = false;



let Options = {
  theme: "primary",
  position: "top-right",
  duration : 3000,
  className: "custom-toast"
}

Vue.use(Toasted, Options)

Vue.use(VueJwtDecode);

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase() 
});

Vue.filter('cpfCnpjMask', (documentId, documentType) => {
  documentId = typeof documentId != 'string' ? documentId.toString() : documentId;
  if (documentType == 'J') {
    documentId = documentId.padStart(14, '0');
    documentId = documentId.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    documentId = documentId.padStart(11, '0');
    documentId = documentId.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  return documentId;
});

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
